import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { tap } from 'rxjs/operators';
import { ScreeningLight } from 'src/app/models/screeningInvite';
import { ApplicantDataService } from 'src/app/services/applicant-data.service';
import { AuthService } from 'src/app/services/auth.service';
import { RiqAlertComponent } from 'src/app/shared-components-module/riq-alert/riq-alert.component';
import { ScreeningService } from '../../services/screening.service';
import { DisputeTrackerService } from 'src/app/dispute-tracker/dispute-tracker.service';

@Component({
  selector: 'app-email-buttons-panel',
  templateUrl: './email-buttons-panel.component.html',
  styleUrls: ['./email-buttons-panel.component.less']
})
export class EmailButtonsPanelComponent implements OnInit, OnDestroy {

  @Input() screeningToEdit: ScreeningLight;
  
  

  constructor(public auth: AuthService, public toast: ToastrService, public appData : ApplicantDataService, public modalService: NgbModal, public screening: ScreeningService, public dispo: DisputeTrackerService) {
    
  }

  public get showAALButtons() : boolean {
    //this isn't working for some reason -- investigate when we circle back on full refactoring
    // return this.screeningToEdit.showAALButtons;
    if(!this.screeningToEdit) return false;
		if(this.screeningToEdit.propertyDecision && (this.screeningToEdit.propertyDecision.toLowerCase() == 'decline' || this.screeningToEdit.propertyDecision.toLowerCase().includes('conditional'))) return true;
		return false;
  }

  ngOnDestroy(): void {
    // throw new Error('Method not implemented.');
  }
  ngOnInit(): void {
    // throw new Error('Method not implemented.');
  }

  sendDisclosure(){
    let modal = this.modalService.open(RiqAlertComponent, { size: 'lg' });
    modal.componentInstance.name = 'AYS_SendDisclosure';
    modal.componentInstance.title = 'Send consumer copy?';
    modal.componentInstance.alertBody = 'This will generate a copy of the report and email it to the applicant. Please confirm:';
    modal.componentInstance.cancelButtonText = 'Cancel';
    modal.componentInstance.confirmButtonText = 'Send';

    modal.componentInstance.evnt.subscribe((ev)=>{
      this.appData.FireOffConsumerDisclosureEmail(this.screeningToEdit.invitationId).pipe(
        tap(_ => {
          this.toast.success('Disclosure Sent to Applicant');
        },
        (err: any) => {
          this.toast.error('Disclosure Send Failed');

        },()=>{
          this.modalService.dismissAll();
        })
      )
      .subscribe();
    });
  }

  sendIdVerMissingInfoEmail() {
    let modal = this.modalService.open(RiqAlertComponent, { size: 'lg' });
    modal.componentInstance.name = 'AYS_SendIdVerMissingInfo';
    modal.componentInstance.title = 'Send IDVer missing info email?';
    modal.componentInstance.alertBody = 'This will email the IdVer missing info template email to the main property contact. Please confirm:';
    modal.componentInstance.cancelButtonText = 'Cancel';
    modal.componentInstance.confirmButtonText = 'Send';

    modal.componentInstance.evnt.subscribe((ev)=>{
      this.appData.SendIDVerMissingInfoEmail(this.screeningToEdit.id).pipe(
        tap(_ => {
          this.toast.success('IDVer MissingInfo email sent.');
        },
        (err: any) => {
          this.toast.error('IDVer MissingInfo Email send failed');

        },()=>{ 
          this.modalService.dismissAll();
        })
      )
      .subscribe();
    });
  }

  sendIdVerNoPhoneEmail() {
    let modal = this.modalService.open(RiqAlertComponent, { size: 'lg' });
    modal.componentInstance.name = 'AYS_SendIdVerNoPhone';
    modal.componentInstance.title = 'Send IDVer no phone email?';
    modal.componentInstance.alertBody = 'This will email the IdVer no phone number template email to the main property contact. Please confirm:';
    modal.componentInstance.cancelButtonText = 'Cancel';
    modal.componentInstance.confirmButtonText = 'Send';

    modal.componentInstance.evnt.subscribe((ev)=>{
      this.appData.SendIDVerNoPhoneEmail(this.screeningToEdit.id).pipe(
        tap(_ => {
          this.toast.success('IDVer NoPhone email sent.');
        },
        (err: any) => {
          this.toast.error('IDVer NoPhone Email send failed');

        },()=>{ 
          this.modalService.dismissAll();
        })
      )
      .subscribe();
    });
  }

  sendAdverseActionLetter() {
    if(!this.screeningToEdit.applicantEmail) this.toast.error('Applicant does not have an email address listed.', 'Email error', { closeButton: true, disableTimeOut: true });

    let modal = this.modalService.open(RiqAlertComponent, { size: 'lg' });
    modal.componentInstance.name = 'AYS_SendAALEmail';
    modal.componentInstance.title = 'Send AAL?';
    modal.componentInstance.alertBody = 'This will generate and email an Adverse Action Letter to the applicant. Please confirm:';
    modal.componentInstance.cancelButtonText = 'Cancel';
    modal.componentInstance.confirmButtonText = 'Send';

    modal.componentInstance.evnt.subscribe((ev)=>{
      this.screening.SendAdverseActionLetter(this.screeningToEdit.invitationId).pipe(
        tap(() => { this.toast.success('Sending Adverse Action Letter ...'); },
        err => { this.toast.error('Error sending AAL!', '', { closeButton: true, disableTimeOut: true }) },
        () => {
          this.modalService.dismissAll();
        })
      ).subscribe();
    });


  }

}
